import Pagination from "components/Common/newPagination";
import { useState, useEffect } from "react";
import trackServices from "./trackServices";
import ViewContractReleaseAsset from "components/MetaData/Release/ViewContractReleaseAsset";
import TrackDetailsForm from "./TrackDetailsForm";
import ContractAssetLink from "../contractAssetLink";

export default function AssociatedTracks(contractDetails: any) {

    console.log(contractDetails)
    let [totalRows, setTotalRows] = useState(0);
    let [viewContract, setviewContract] = useState(false);
    let [TrackDetailsOpen, setTrackDetailsOpen] = useState(false);
    let [AssociatedTracks, initAssociatedTracks] = useState<any>([]);
    let [TrackDetailSelect, setTrackDetailSelect] = useState<any>([]);
    let [viewContractSelect, setviewContractSelect] = useState<any>([]);
    let [ContractAssetLinkOpen, setContractAssetLinkOpen] = useState(false);

    const handleNameOnChange = (n: any) => {
        Data.pageNumber = n.pageNumber;
        Data.pageSize = n.pageSize;
        console.log(Data);
        getTrackes()
    }

    useEffect(() => {
        if (contractDetails?.contractDetails?.setContract?.length > 0) {
            Data.contractRefNum = contractDetails?.contractDetails?.setContract.contractRefNum
        }
        getTrackes()
    }, []);

    const Data: any = {
        pageSize: 10,
        pageNumber: 1,
        contractRefNum: contractDetails?.contractDetails?.contractRefNum
    }

    const getTrackes = () => {
        console.log(Data);
        trackServices.AssociatedTracks(Data).then((res) => {
            //console.log(res);
            initAssociatedTracks(res)
            setTotalRows(res[0].totalRows ? res[0].totalRows : 0)
            console.log(totalRows)
        })
    }

    const ViewContractReleaseChange = (e: any) => {
        viewContract = false
        setviewContract(viewContract)
    }

    const onChangTrackDetailsForm = (e: any) => {
        console.log(e)
        TrackDetailsOpen = false;
        setTrackDetailsOpen(TrackDetailsOpen)
    }

    const onChangContractAssetLink = (e: any) => {
        console.log(e)
        ContractAssetLinkOpen = false;
        setContractAssetLinkOpen(ContractAssetLinkOpen)
    }

    const exportFullListing = () => {
        trackServices.AssociatedTrackExport(Data)
    }

    return (

        <div className="ws-12">
            <div className="box-content p0">

                <div className="ws-12 pm">
                    <h3 className="capitalize mb pull-left ws-5 ptl">  Associated track ({totalRows})  </h3>

                    <button className="icon-btn info pull-right height35" onClick={exportFullListing}>  <i className="icon-download"></i></button>
                    <button className="icon-btn edit pull-right mb height35" onClick={() => { setTrackDetailsOpen(true); setTrackDetailSelect({}) }}> Add New Track</button>
                    <button className="icon-btn edit pull-right mb height35" onClick={() => setContractAssetLinkOpen(true)}> Link Track</button>

                </div>

                {(totalRows > 0) && <table className="newTable">
                    <thead>
                        <tr>
                            <th>ISRC</th>
                            <th>Artist Name</th>
                            <th>Title</th>
                            <th>Duration</th>
                            <th style={{ width: "120px" }}>Operation</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            AssociatedTracks.map((post: any) => (
                                <tr>
                                    <td>{post.iSRC}
                                        <button className="icon-btn info pull-right" onClick={() => { setviewContract(true); setviewContractSelect(post) }}>
                                            <i className="icon-price-list"></i>
                                        </button>
                                    </td>
                                    <td>{post.kontactName}</td>
                                    <td>{post.trackName}</td>
                                    <td>{post.trackDuration}</td>
                                    <td >
                                        <div className="width200">
                                            <button className="icon-btn edit" onClick={() => { setTrackDetailsOpen(true); setTrackDetailSelect(post) }}> <i className="icon-edit"></i>  </button>
                                            <button className="icon-btn delete" onClick={() => setContractAssetLinkOpen(true)}>   <i className="icon-trashcan"></i>   </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }

                    </tbody>
                </table>}

                {
                    (() => {
                        if (totalRows > 1 && totalRows > 10) {
                            return <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                        }
                        if (totalRows === 0) {
                            return <div className="alert alert-info mt mrl mbl"> No data to display</div>
                        }

                    })()
                }
            </div>

            {
                (() => {

                    if (viewContract) {
                        return <ViewContractReleaseAsset ViewContractReleaseChange={ViewContractReleaseChange} type="track"
                            viewContract={viewContract} viewContractSelect={viewContractSelect} />
                    }

                    if (ContractAssetLinkOpen) {
                        return <ContractAssetLink onChangContractAssetLink={onChangContractAssetLink} ContractAssetLinkOpen={ContractAssetLinkOpen} type="Tracks" contractDetails={contractDetails?.contractDetails} />
                    }

                    if (TrackDetailsOpen) {
                        return <TrackDetailsForm TrackDetailsOpen={TrackDetailsOpen} onChangTrackDetailsForm={onChangTrackDetailsForm} TrackDetailSelect={TrackDetailSelect} />
                    }

                })()
            }

        </div>
    )
}